<div ngModelGroup="comboFuncionario-{{data}}" fxFlex="100" fxLayoutGap="20px" fxFlexOffset="20px">
    <combo-pesquisavel #comboFuncionario 
                       nome="funcionario-{{data}}" 
                       [itens]="dados" 
                       itemId="id"
                       [itemDescricao]="itemDescricao"
                       [showDisplayId]="showDisplayId" 
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Nome do funcinário"
                       [label]="label"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>

